import { inject, Service } from "@angular/core";

import { MainResponseModel } from "../models/main-response-model";
import {
  OperationStrategicTask,
  OperationStrategicTaskOption,
  OperationStrategicTaskProcedure,
} from "../models/operation-strategic-task-model";
import { MainService } from "./main-service";

@Service()
export class OperationStrategicTaskApiService {
  private readonly _apiPrefix = "operation-strategic-task";
  private readonly _mainService = inject(MainService);

  public getById(itemType: number, id: number) {
    return this._mainService.sendRequest<MainResponseModel<OperationStrategicTask>>({
      method: "GET",
      url: `${this._apiPrefix}/getById?itemType=${itemType}&id=${id}`,
    });
  }

  public save(item: OperationStrategicTask, isEdit: boolean) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url: `${this._apiPrefix}/${isEdit ? "update" : "create"}`,
      data: item,
    });
  }

  public deleteById(itemType: number, id: number) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "DELETE",
      url: `${this._apiPrefix}/delete?itemType=${itemType}&id=${id}`,
    });
  }

  public getProcedureById(id: number) {
    return this._mainService.sendRequest<MainResponseModel<OperationStrategicTaskProcedure>>({
      method: "GET",
      url: `${this._apiPrefix}/getProcedureById?id=${id}`,
    });
  }

  public getAvailableForReading(entityId: number, kpiId: number, type?: number) {
    const typeParam = type === undefined ? "" : `&type=${type}`;

    return this._mainService.sendRequest<MainResponseModel<OperationStrategicTaskOption[]>>({
      method: "GET",
      url: `${this._apiPrefix}/getAvailableForReading?entityId=${entityId}&kpiId=${kpiId}${typeParam}`,
    });
  }
}
